const cleanUrlDuplicateSlashes = url => {
  if (!url || url.startsWith('http')) return url;
  url = url.replace(/\/\/+/g, '/');
  if (url.charAt(0) !== '/' && url.charAt(0) !== '#') url = '/' + url;
  return url;
};
export { cleanUrlDuplicateSlashes };
//# sourceMappingURL=cleanUrlDuplicateSlashes.js.map
